import axios from "axios";
import { API_URL_COMMON } from "./http.common";

// const API_URL = `https://magicstamp-portal-sa.parktechnology.com`;
const API_URL = `${API_URL_COMMON}`;

class Service {
  signin(userData) {
    const config = {
      method: "post",
      url: `${API_URL}/auth/login`,
      data: userData,
    };
    return axios(config);
  }

  acceptInvite(userData) {
    return axios({
      method: "post",
      url: `${API_URL}/invites/invite/accept`,
      data: userData,
    });
  }
}

const service = new Service();

export default service;
